<template>
  <div class="page-shell">
    <section class="container auth-container">
      <div class="page-intro auth-intro">
        <p class="eyebrow">Member Login</p>
        <h1 class="page-title">登录会员账号</h1>
      </div>

      <form class="panel auth-panel" @submit.prevent="handleSubmit">
        <div v-if="errorMessage" class="status-card is-error">{{ errorMessage }}</div>

        <div class="form-grid">
          <label class="form-field form-field--full">
            <span class="form-label">手机号</span>
            <input v-model.trim="form.mobile" type="tel" placeholder="请输入手机号">
          </label>

          <label class="form-field form-field--full">
            <span class="form-label">密码</span>
            <input v-model.trim="form.password" type="password" placeholder="请输入密码">
          </label>
        </div>

        <label class="remember-row">
          <input v-model="form.remember" type="checkbox">
          <span>保持 7 天登录态</span>
        </label>

        <div class="auth-actions">
          <button class="btn btn--primary" type="submit" :disabled="submitting">
            {{ submitting ? '登录中...' : '立即登录' }}
          </button>
          <router-link class="btn btn--ghost" :to="{ name: 'reset-password' }">
            忘记密码
          </router-link>
        </div>

        <p class="muted">
          还没有账号？
          <router-link class="text-link" :to="{ name: 'register' }">前往注册</router-link>
        </p>
      </form>
    </section>
  </div>
</template>

<script>
import { loginMember } from '@/api/auth'
import { applyAuthSession, hydrateSession } from '@/store/session'

export default {
  name: 'LoginView',
  data() {
    return {
      submitting: false,
      errorMessage: '',
      form: {
        mobile: '',
        password: '',
        remember: true
      }
    }
  },
  created() {
    if (this.$route.query.mobile) {
      this.form.mobile = String(this.$route.query.mobile)
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.form.mobile || !this.form.password) {
        this.errorMessage = '请输入手机号和密码。'
        return
      }

      this.submitting = true
      this.errorMessage = ''

      try {
        const session = await loginMember({
          mobile: this.form.mobile,
          password: this.form.password,
          remember: this.form.remember ? 1 : 0
        })

        applyAuthSession(session)
        await hydrateSession().catch(() => {})

        this.$router.push(this.$route.query.redirect || { name: 'profile' })
      } catch (error) {
        this.errorMessage = error.message || '登录失败'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.auth-container {
  max-width: 620px;
}

.auth-intro {
  margin-bottom: 20px;
}

.auth-panel {
  display: grid;
  gap: 18px;
  padding: 24px;
}

.remember-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: $color-text-secondary;
}

.remember-row input {
  width: auto;
  padding: 0;
}

.auth-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.text-link {
  color: $color-primary;
  font-weight: 700;
}

@media (max-width: 640px) {
  .auth-panel {
    padding: 20px;
  }
}
</style>
